export default __webpack_public_path__ + "static/FreightTextProBold-Regular-591aea48a2480f7423468e0db9b9b529.woff2";